import { handleActions } from 'redux-actions';
import moment from 'moment';

// const MORNING = [
// 	{
// 		time: '2018-06-01 00:00:00',
// 		live: 5,
// 		phone: 5,
// 		online: 5,
// 		available: true,
// 	},
// 	{
// 		time: '2018-06-01 00:30:00',
// 		live: 5,
// 		phone: 5,
// 		online: 5,
// 		available: true,
// 	},
// 	{
// 		time: '2018-06-01 01:00:00',
// 		live: 5,
// 		phone: 5,
// 		online: 5,
// 		available: true,
// 	},
// ];

const defaultForm = {
	phone: {
		value: '',
		country: {
			areaCodes: null,
			dialCode: '886',
			iso2: 'tw',
			name: 'Taiwan (台灣)',
			priority: 0,
		},
		validate: false,
		status: '',
	},

	hangout: { value: '', status: '', valid: false },
};

export default handleActions(
	{
		CHANGE_RESERVATION_STEP: (state, action) => ({
			...state,
			step: action.payload.step,
		}),

		CLEAR_RESERVATION_TIME: state => ({
			...state,
			reservationTimeList: { MORNING: [], AFTERNOON: [] },
		}),

		FETCH_RESERVATION_TIME_FULFILLED: (state, action) => ({
			...state,

			reservationTimeList: {
				...state.reservationTimeList,
				...action.payload.reservationTimeList,
			},
		}),

		FETCH_RESERVATION_DATE_FULFILLED: (state, action) => ({
			...state,

			reservationDate: {
				...state.reservationDate,
				...action.payload.reservationDate,
			},
		}),

		RESERVE_PROCESS_FULFILLED: (state, action) => ({
			...state,
			...action.payload,
		}),

		FETCH_RESERVATION_FULFILLED: (state, action) => ({
			...state,

			reservations: {
				list: action.payload.list,
				data: { ...state.reservations.data, ...action.payload.data },
			},
		}),

		FETCH_USER_OVERVIEW_FULFILLED: (state, action) => ({
			...state,

			reservations: {
				list: action.payload.reservationList,
				data: { ...state.reservations.data, ...action.payload.reservationData },
			},
		}),

		FETCH_RESERVATION_BY_ID_FULFILLED: (state, action) => ({
			...state,

			reservations: {
				...state.reservations,
				data: {
					...state.reservations.data,
					[action.payload.data.id]: action.payload.data,
				},
			},
		}),

		UPDATE_RESERVATION_FIELD: (state, action) => ({
			...state,

			[action.payload.type]: {
				...state[action.payload.type],
				[action.payload.key]: {
					...state[action.payload.type][action.payload.key],
					...action.payload.value,
				},
			},
		}),

		INIT_RESERVATION_FORM_DATA: state => ({
			...state,

			form: defaultForm,
		}),

		SET_RESERVATION_FORM_DATA: (state, action) => ({
			...state,

			form: {
				phone: {
					validate: false,
					status: 'FINISHED',
					...action.payload.phone,
				},
				hangout: {
					status: 'FINISHED',
					valid: false,
					...action.payload.hangout,
				},
			},
		}),

		SET_ACCESS_RESERVE: state => ({
			...state,
			canAccess: true,
		}),
	},
	{
		step: 'reservation',
		reservationTimeList: { MORNING: [], AFTERNOON: [] },
		reservationDate: {},
		roomId: 0,
		type: 'live',
		time: moment().valueOf(),
		email: '',
		canAccess: false,

		reservations: {
			list: [],
			data: {},
		},

		form: defaultForm,
	},
);



// WEBPACK FOOTER //
// ./src/reducers/reservation.js